import ConfirmModal from "server/components/Modals/ConfirmModal";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { Button, useNotify, useRefresh } from "react-admin";
import dataProvider from "server/dataProvider";

const StatusToggleDialog = ({
  isActive, activateUrl, deactivateUrl, confirmMessage, successMessage, disabled = false,
}) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async () => {
    await dataProvider.customRequest(isActive ? deactivateUrl : activateUrl, null, "PUT");
    notify(successMessage, { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      onConfirm={handleSubmit}
      titleContent={isActive ? "Смени статуса на Неактивен" : "Смени статуса на Активен"}
      triggerButton={
        <Button
          type="button"
          startIcon={<AutorenewIcon />}
          label={isActive ? "Деактивирай" : "Активирай"}
          disabled={disabled}
        />
      }
      message={confirmMessage}
    />
  );
};

export default StatusToggleDialog;
